<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(apply)" class="pb-2">
      <div class="d-flex pt-3 pl-2 pr-2">
        <div class="px-1">
          <VueSelect
            class="input_form_order_dialog"
            data-test="divisionOrders-orderDialogForm-product-select"
            rules="required"
            ref="productNameSelect"
            infinite
            @input="onChangeProductGroup"
            :getItemPromise="
              ({ text, page }) =>
                $store.dispatch('getProductOfficeType', {
                  forOffice: true,
                })
            "
            v-model="productFilter.group_id"
            :label="$t('category')"
            :items="productGroups"
            @item-resolved="setProductGroup"
            @next-page-resolved="(data) => setProductGroup([...data])"
          >
          </VueSelect>
        </div>
        <div class="px-1">
          <VueSelect
            class="input_form_order_dialog"
            data-test="divisionOrders-orderDialogForm-product-select"
            rules="required"
            ref="productNameSelect"
            infinite
            @input="onSelectProduct"
            :getItemPromise="
              ({ text, page }) =>
                $store.dispatch('getTnVdProduct', {
                  page,
                  limit: 10,
                  categoryId: productFilter.group_id,
                })
            "
            @next-page-resolved="
              (products) =>
                (orderItemData.products = [
                  ...orderItemData.products,
                  ...products,
                ])
            "
            @item-resolved="
              (products) => $set(orderItemData, 'products', products)
            "
            v-model="orderItemData.product_id"
            :label="$t('product')"
            :items="orderItemData.products"
          >
            <template #option="{ item }">
              <VListItemContent>
                <VListItemTitle>
                  <p class="ma-0">{{ item.name }}</p>
                </VListItemTitle>
                <div>
                  <span
                    style="font-size: 11px"
                    class="font-weight-bold"
                    v-if="item.attrs"
                    >{{ item.attrs.join(" && ") }}</span
                  >
                </div>
              </VListItemContent>
            </template>
          </VueSelect>
        </div>
        <!--        <div class="px-1">-->
        <!--          <VueSelect-->
        <!--            data-test="divisionOrders-orderDialogForm-measure-select"-->
        <!--            rules="required"-->
        <!--            v-model="orderItemData.unitTypeId"-->
        <!--            :label="$t('measure')"-->
        <!--            @input="isChanged = true"-->
        <!--            :items="unitTypes"-->
        <!--            @focus="onFocusUnitTypeSelect"-->
        <!--            :item-text="`name_${$i18n.locale}`"-->
        <!--            class="input_form_order_dialog"-->
        <!--          ></VueSelect>-->
        <!--        </div>-->
        <div class="px-1">
          <CustomInputText
            data-test="divisionOrders-orderDialogForm-count-inputText"
            rules="required"
            type="number"
            step="any"
            :label="$t('count')"
            min="1"
            max="100000000"
            @input="isChanged = true"
            :data-id="`order-item-product-count-${index}`"
            v-model="orderItemData.count"
            class="user_input no-margin input_form_order_dialog"
          ></CustomInputText>
        </div>
        <div class="px-1 flex-shrink-0" style="margin-top: 20px">
          <VBtn
            data-test="divisionOrders-orderDialogForm-submit-btn"
            type="submit"
            class="btn_33 mr-1 plus_btn pulse-button"
            :data-id="`order-item-submit-btn-${index}`"
          >
            <vue-icon icon="checkIcon"></vue-icon>
          </VBtn>
          <VBtn
            @click="$emit('cancel')"
            class="btn_33 delete_btn pulse-button"
            data-test="divisionOrders-orderDialogForm-reject-btn"
          >
            <VueIcon icon="rejectIcon" />
          </VBtn>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import VueSelect from "@/components/ui/vue-select/VueSelect";
import { getQueryByKey } from "@/utils/pureFunctions";

const DEFAULT_ORDER_ITEM = {
  products: [],
  product_id: null,
  productGroups: [],
  // unitTypeId: null,
  count: null,
};

export default {
  name: "OrderDialogForm",
  props: {
    index: {},
    item: {
      type: Object,
      default() {
        return {
          ...DEFAULT_ORDER_ITEM,
        };
      },
    },
  },
  data() {
    return {
      isChanged: false,
      orderItemData: {},
      accountingCode: null,
      productFilter: {
        group_id: null,
      },
      productGroups: [],
    };
  },
  methods: {
    setProductGroup(productGroups) {
      this.productGroups = productGroups;
    },
    async onChangeProductGroup(val) {
      const { productNameSelect } = this.$refs;

      const { data, lastPage } = await this.$store.dispatch("getTnVdProduct", {
        page: 0,
        limit: 15,
        categoryId: val,
      });
      this.orderItemData.products = data;
      productNameSelect.page++;
      productNameSelect.lastPage = lastPage;
    },
    async onFocusUnitTypeSelect() {
      if (this.orderItemData.product_id && this.unitTypes.length < 2) {
        const {
          data: { data },
        } = await this.$http.get("product/get-product-unittypes", {
          params: { id: this.orderItemData.product_id },
        });
        if (data.unitTypes) {
          this.unitTypes = data.unitTypes;
        }
      }
    },
    // getProductCode: debounce(async function () {
    //   try {
    //     const {
    //       data: { data },
    //     } = await this.$http.get(
    //       "product-item/get-product-by-accounting-code",
    //       {
    //         params: { accountingCode: this.accountingCode },
    //       }
    //     );
    //     if (data) {
    //       this.orderItemData.products = [data];
    //       this.orderItemData.product_id = data.id;
    //       if (data.unitTypes.length === 1) {
    //         data.unitTypes.map((item) => {
    //           this.orderItemData.unitTypeId = item.id;
    //         });
    //       } else {
    //         this.orderItemData.unitTypeId = null;
    //       }
    //       const { productNameSelect } = this.$refs;
    //       productNameSelect.reset();
    //     }
    //   } catch (err) {
    //     this.setResponseError({ error: err });
    //   }
    // }, 300),
    apply() {
      const selectedProduct = this.orderItemData.products.find(
        (product) => product.id === this.orderItemData.product_id
      );
      const selectedProductGroup = this.orderItemData.productGroups.find(
        (productGroup) => productGroup.id === this.productFilter.group_id
      );
      // const unitType = this.unitTypes.find(
      //   (item) => item.id === this.orderItemData.unitTypeId
      // );
      const data = {
        ...this.orderItemData,
        isChanged: true,
        isEditing: false,
        // [`unit_type_name_${this.$i18n.locale}`]: unitType[`name_${this.$i18n.locale}`],
        statusCode: "NEW",
        isNew: false,
      };
      if (selectedProduct) {
        data.productName = selectedProduct.name;
      }
      if (selectedProductGroup) {
        data.productGroupName = selectedProductGroup.name;
      }
      this.$emit("apply", data);
    },
    onSelectProduct() {
      this.isChanged = true;
      this.$nextTick(() => {
        // if (this.unitTypes.length === 1) {
        //   this.orderItemData.unitTypeId = this.unitTypes[0].id;
        // }
      });
    },
  },
  components: { VueSelect },
  computed: {
    // unitTypes: {
    //   get() {
    //     console.log(this.orderItemData.product_id, this.orderItemData.products);
    //     if (this.orderItemData.product_id) {
    //       const selectedProduct = this.orderItemData.products.find(
    //         (item) => item.id === this.orderItemData.product_id
    //       );
    //       if (selectedProduct) {
    //         return selectedProduct.unitTypes;
    //       }
    //     }
    //     return [];
    //   },
    //   set(unitTypes) {
    //     if (this.orderItemData.product_id) {
    //       const selectedProduct = this.orderItemData.products.find(
    //         (item) => item.id === this.orderItemData.product_id
    //       );
    //       if (selectedProduct) {
    //         selectedProduct.unitTypes = unitTypes;
    //       }
    //     }
    //   },
    // },
  },
  created() {
    this.orderItemData = getQueryByKey(DEFAULT_ORDER_ITEM, this.item);
  },
};
</script>

<style>
.input_form_order_dialog {
  min-width: 150px !important;
}

.pulse-button {
  border-radius: 50%;
  margin: 10px;
  height: 20px;
  width: 20px;

  background: rgba(255, 82, 82, 1);
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
}

.pulse-button.plus_btn {
  background: #68b833;
  box-shadow: 0 0 0 0 #68b833;
  transition: 0.5s;
}
</style>
